import colaborador from "./colaborador";

export default (httpClient) => ({
  salvarProdutosLidos: async ({ token, pedido_id, colaborador_id, itens_pedido }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.post(
      "/atualizar-status-pedidos/" + pedido_id,
      { status: "EMBALADO", colaborador_id, itens_pedido, pontuacao:"SIM"},
      { headers }
    );
    return {
      data: response.data,
    };
  },
  informacoes: async ({ cliente_id, page, dias, token }) => {
    console.log(dias);
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.post(
      "/dados-dashboard/" + cliente_id,
      { page, dias },
      { headers }
    );
    return {
      data: response.data,
    };
  },
  
  atualizarPedidos: async ({ token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/importar-pedidos", { headers });
    return {
      data: response.data,
    };
  },
  getAll: async ({ token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/pedidos", { headers });
    return {
      data: response.data,
    };
  },
  buscarPorStatus: async ({ token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/pedidos-por-status", { headers });
    return {
      data: response.data,
    };
  },
  pacotesDoDia: async ({ token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/pacotes-do-dia", { headers });
    return {
      data: response.data,
    };
  },

  pacotesDoDiaAdmin: async ({ token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/pacotes-do-dia-admin", { headers });
    return {
      data: response.data,
    };
  },

  pacotesDoDiaBipagem: async ({ token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/pacotes-do-dia-bipagem", { headers });
    return {
      data: response.data,
    };
  },
  pacotesDoDiaBipagemAdmin: async ({ token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/pacotes-do-dia-bipagem-admin", { headers });
    return {
      data: response.data,
    };
  },
  pacotesDoDiaEmbalar: async ({ token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/pacotes-do-dia-embalar-admin", { headers });
    return {
      data: response.data,
    };
  },
  pacotesDoDiaEmbalarAdmin: async ({ token }) => {
    const headers = {
      Authorization: "Bearer " + token,
      Accept: "application/json",
    };
    const response = await httpClient.get("/pacotes-do-dia-embalar-admin", { headers });
    return {
      data: response.data,
    };
  },
});
